export default __webpack_public_path__ + "static/media/compass.a51163a9.svg";